import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  inject,
  OnInit,
} from '@angular/core';
import { ThemeService } from 'src/app/core/services/theme/theme.service';

@Component({
  selector: 'app-pill-tab-button',
  templateUrl: './pill-tab-button.component.html',
  styleUrls: ['./pill-tab-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PillTabButtonComponent implements OnInit {
  @Input({ required: true }) label!: string;
  @Input() isSelected = true;
  @Output() clickEvent = new EventEmitter<void>();

  themeService = inject(ThemeService);

  hasShadow = false;
  hasOutline = false;

  ngOnInit() {
    this.hasShadow = this.themeService.buttonConfig().primary.shadow;
  }

  onClick(): void {
    this.clickEvent.emit();
  }
}
